module.exports = __webpack_public_path__ + "images/emoji/yum.1ff8b2c9880c88899b5d.png";